export class User {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    mailto: string;
    phone: string;
    password: string;
    }